export class Licenciamento {
    ativo: boolean;
    finalPlaca: number;
    mes: number;
    estadoId: number;
    id: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/shared/licenciamento.model.ts
 **/